<script>
import pieChart from "../analisis/pieChart";
    export default {
        components: { pieChart },
        props:[
            'colegio'
        ],
        data(){
            return{
                columnDatalabelChart: {
                    series: [{
                        name: 'Promedio',
                        data: this.series//[2.5, 3.2, 5.0, 10.1, 4.2, 3.8, 3, 2.4, 4.0, 1.2, 3.5, 0.8]
                    }],
                    chartOptions: {
                        chart: {
                            toolbar: {
                                show: false,
                            }
                        },
                        plotOptions: {
                            bar: {
                                dataLabels: {
                                    position: 'top', // top, center, bottom
                                },
                            }
                        },
                        dataLabels: {
                            enabled: true,
                            formatter: function (val) {
                                return val + "%";
                            },
                            offsetY: -20,
                            style: {
                                fontSize: '12px',
                                colors: ["#304758"]
                            }
                        },
                        colors: ['#556ee6'],
                        grid: {
                            borderColor: '#f1f1f1',
                        },
                        xaxis: {
                            categories: ["Coordinadores", "Docente", "Asistente de la Educación", "Auxiliar" , "Jefe de Departamento", "Profesor Jefe", "Encargado de Convivencia"],
                            position: 'top',
                            labels: {
                                offsetY: -18,

                            },
                            axisBorder: {
                                show: false
                            },
                            axisTicks: {
                                show: false
                            },
                            crosshairs: {
                                fill: {
                                    type: 'gradient',
                                    gradient: {
                                        colorFrom: '#D8E3F0',
                                        colorTo: '#BED1E6',
                                        stops: [0, 100],
                                        opacityFrom: 0.4,
                                        opacityTo: 0.5,
                                    }
                                }
                            },
                            tooltip: {
                                enabled: true,
                                offsetY: -35,

                            }
                        },
                        fill: {
                            gradient: {
                                shade: 'light',
                                type: "horizontal",
                                shadeIntensity: 0.25,
                                gradientToColors: undefined,
                                inverseColors: true,
                                opacityFrom: 1,
                                opacityTo: 1,
                                stops: [50, 0, 100, 100]
                            },
                        },
                        yaxis: {
                            axisBorder: {
                                show: false
                            },
                            axisTicks: {
                                show: false,
                            },
                            labels: {
                                show: false,
                                formatter: function (val) {
                                    return val + "%";
                                }
                            }

                        },
                        title: {
                            text: '',
                            floating: true,
                            offsetY: 320,
                            align: 'center',
                            style: {
                                color: '#444'
                            }
                        },
                    }
                },
                auto:0,
                auto_resp:0,
                co:0,
                co_resp:0,
                jefe:0,
                jefe_resp:0,
                retro:0,
                retro_resp:0,
                grafico1:[],
                grafico2:[],
                grafico3:[],
                grafico4:[],
                hola:'',
                series:[]
            }
        },
        methods:{
            porc(encuesta){
                let suma1 = Math.round((parseInt(encuesta.p1)+ parseInt(encuesta.p2)+ parseInt(encuesta.p3)+ parseInt(encuesta.p4)+ parseInt(encuesta.p5))/5);
                let suma2 = Math.round((parseInt(encuesta.p6)+ parseInt(encuesta.p7)+ parseInt(encuesta.p8)+ parseInt(encuesta.p9)+ parseInt(encuesta.p10))/5);
                let suma3 = Math.round((parseInt(encuesta.p11)+ parseInt(encuesta.p12)+ parseInt(encuesta.p13)+ parseInt(encuesta.p14)+ parseInt(encuesta.p15))/5);
                let suma = suma1*0.333+suma2*0.333+suma3*0.333;
                return ((100*suma)/4).toFixed(2);
            }
        },
        created(){
            /*axios.get('/api/get_promedio/'+this.colegio).then(res=>{//asistente de la educación
                this.series = res.data.series;
                //console.log(this.columnDatalabelChart.series);
                
            });*/
            axios.get('/api/get_dashboard/'+this.colegio).then(res=>{
                this.auto = res.data.auto_total;
                this.auto_resp = res.data.auto_resp;
                this.co = res.data.co_total;
                this.co_resp = res.data.co_resp;
                this.jefe = res.data.jefe_total;
                this.jefe_resp = res.data.jefe_resp;
                this.retro = res.data.retro_total;
                this.retro_resp = res.data.retro_resp;
                this.grafico1= res.data.grafico1;
                this.grafico2= res.data.grafico2;
                this.grafico3= res.data.grafico3;
                this.grafico4= res.data.grafico4;
                
            });
            
        }
    }
</script>
<template>
    <div class="row">
        <div class="col-md-3">
            <div class="card mini-stats-wid">
                <div class="card-body">
                    <h5 class="text-muted font-weight-medium">Autoevaluación Total</h5>      
                    <h4 class="float-right mb-0">
                        {{ auto }}
                    </h4>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card mini-stats-wid">
                <div class="card-body">
                    <h5 class="text-muted font-weight-medium">Coevaluación Total</h5>      
                    <h4 class="float-right mb-0">
                        {{ co }}
                    </h4>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card mini-stats-wid">
                <div class="card-body">
                    <h5 class="text-muted font-weight-medium">Evaluación del jefe Total</h5>      
                    <h4 class="float-right mb-0">
                        {{ jefe }}
                    </h4>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card mini-stats-wid">
                <div class="card-body">
                    <h5 class="text-muted font-weight-medium">Retroalimentación Total</h5>      
                    <h4 class="float-right mb-0">
                        {{ retro }}
                    </h4>
                </div>
            </div>
        </div>
        <div class="col-md-6 mt-3">
            <div class="card">
                <div class="card-body">
                    <pieChart :title="'Autoevaluación'" :labels="grafico1.label" :series="[grafico1.series[0],grafico1.series[1]]"/>
                </div>
            </div>
        </div>
        <div class="col-md-6 mt-3">
            <div class="card">
                <div class="card-body">
                    <pieChart :title="'Coevaluación'" :labels="grafico2.label" :series="[grafico2.series[0],grafico2.series[1]]"/>
                </div>
            </div>
        </div>
        <div class="col-md-6 mt-3">
            <div class="card">
                <div class="card-body">
                    <pieChart :title="'Evaluación del Jefe'" :labels="grafico3.label" :series="[grafico3.series[0],grafico3.series[1]]"/>
                </div>
            </div>
        </div>
        <div class="col-md-6 mt-3">
            <div class="card">
                <div class="card-body">
                    <pieChart :title="'Retroalimentación'" :labels="grafico4.label" :series="[grafico4.series[0],grafico4.series[1]]"/>
                </div>
            </div>
        </div>
        <!-- <div class="col-md-12 mt-3">
            <div class="card">
                <div class="card-body">
                    <h4>Promedio de las evaluaciones</h4>
                    <apexchart
                        class="apex-charts"
                        height="350"
                        type="bar"
                        dir="ltr"
                        :series="columnDatalabelChart.series"
                        :options="columnDatalabelChart.chartOptions"
                    ></apexchart>
                </div>
            </div>
        </div> -->
    </div>
    <!-- <h4>Autoevaluación</h4>
                    <apexchart
                        class="apex-charts"
                        height="350"
                        type="bar"
                        dir="ltr"
                        :series="columnDatalabelChart.series"
                        :options="columnDatalabelChart.chartOptions"
                    ></apexchart> -->
</template>
<style lang="scss" scoped>

</style>